import { useEffect } from "react";
import { useFetchFeature } from "../../utils/features";
import { GTMTrackingSetupComplete } from "./trackingService";

export default function GTMScriptLoader() {
    const { enabled, settings } = useFetchFeature("gtm");
    const key = settings?.["id"];
    const auth = settings?.["auth"] || "";
    const preview = settings?.["preview"] || "";
    useEffect(() => {
        if (!enabled || document.getElementById("gtmScript")) {
            return;
        }
        let targetEnvironmentParameters = "";
        if (auth && preview) {
            targetEnvironmentParameters = `&gtm_auth=${auth}&gtm_preview=${preview}&gtm_cookies_win=x`;
        }
        const gtmScript = document.createElement("script");
        gtmScript.innerText = `\
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+'${targetEnvironmentParameters}';f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${key}');\
            `;
        gtmScript.id = "gtmScript";
        const headElement = document.getElementsByTagName("head")[0];
        headElement.appendChild(gtmScript);
        const gtmIframe = document.createElement("noscript");
        gtmIframe.innerText = `\
                <iframe src="https://www.googletagmanager.com/ns.html?id=${key}${targetEnvironmentParameters}" height="0" width="0" style="display:none;visibility:hidden"></iframe>\
            `;
        gtmIframe.id = "gtmIframe";
        const bodyElement = document.getElementsByTagName("body")[0];
        bodyElement.appendChild(gtmIframe);
        //setting matomo tracking config only once
        GTMTrackingSetupComplete();
    }, [enabled, key, auth, preview]);
    return null;
}
